// import { css } from "@emotion/react";
import { rem } from "./utils";

export const mobile = `max-width: ${rem(650)}`;
export const desktop = `min-width: ${rem(651)}`;
export const large = `min-width: ${rem(940)}`;
